import React, { useEffect, useCallback } from "react";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import { ModalV2 } from "components/Modal/ModalV2";
import RegularButton from "components/CustomButtons/Button";
import { useSelector, useDispatch } from "react-redux";
import { useToggle } from "hooks/useToggle";
import { useSearch } from "hooks/useSearch";
import { useValidateReload } from "hooks/useValidateReload";
import { dateValidator } from "helpers/dateValidator";
import { handleCreditsUnlockInputsAction, getCreditsUnlockAction } from "redux/actions/creditsUnlock/creditsUnlockActions";
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { columns } from "./columns";
import { CreditsUnlockForm } from "./CreditsUnlockForm";
const tableKey = "creditsUnlock";
const loadings = ["loadingCreditsUnlock", "loadingModCreditsUnlock"];

export const CreditsUnlockView = () => {
  const dispatch = useDispatch();
  const { creditsUnlock, startDate, endDate, station } = useSelector(({ creditsUnlock }) => creditsUnlock);
  const { buildTableConfig, setSnackbar } = useSearch();
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const [open, handleOpen] = useToggle();

  useValidateReload(loadings);
  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault()
    if(station?.length === 0){
      setSnackbar("Falta seleccionar planta")
      return
    }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getCreditsUnlockAction(startDate, endDate, station))
  }, [station, startDate, endDate, setSnackbar, dispatch]);

  return (
    <>
      <CardTable
        data={creditsUnlock}
        columns={columns}
        hasHeader
        blockBtn
        title={"Desbloqueo de Cuentas de Crédito"}
        icon={<CreditScoreIcon />}
        isLoading={isLoadingComp?.loadingCreditsUnlock}
        tableContent={
          <TableInputs
            reducer="creditsUnlock"
            dates
            stations
            multiStations
            dispatchAction={handleCreditsUnlockInputsAction}
            submitAction={handleSubmit}
          />
        }
        tableKey={tableKey}
        hasControl
        controls={
          <RegularButton round justIcon color="info" onClick={handleOpen}>
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      <ModalV2
        open={open}
        onClose={handleOpen}
        title="Nueva Solicitud"
        justConfirm
      >
        <CreditsUnlockForm  onClose={handleOpen} />
      </ModalV2>
    </>
  );
};